import * as React from "react";
import { Apps28Regular, Apps28Filled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const FindLidApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "FindLid" */ "./FindLidApp");
    return { default: namedExport.FindLidApp };
});

export const FindLid: TeamAppConfig = {
    title: "FindLid",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Store FindLid App for diagnosing LidStacks, StoreIds, and LongOp traces",
    team: "Store",
    publicId: "Exchange\\Store",
    owner: "exstore@microsoft.com",
    role: "*",
    tags: [],
    app: FindLidApp,
    path: "/FindLid"
};
